import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { EventProfile } from '@src/components/sco/Events/EventProfile';
import { QueryContainer } from '@src/components/sco/QueryContainer';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { GroupEvent } from '@src/graphql-types';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
type EventSingleProps = {
  groupEventId: string;
};
const typeKeySlugMap = {
  general: '',
  workshop: 'workshops',
  'office-hours': 'office-hours',
  'group-meetings': 'group-meetings'
};
export const EventSingle = props => {
  const $ = _c(10);
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = EventSingle.queries.groupEvent();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.groupEventId) {
    t1 = {
      variables: {
        groupEventId: props.groupEventId
      }
    };
    $[1] = props.groupEventId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[3] !== activeContent || $[4] !== query.data) {
    t2 = () => {
      const groupEvent = query.data?.groupEvent;
      if (groupEvent?.groupEventId) {
        activeContent.setSiteSection("events.single");
        activeContent.setItem(groupEvent);
        activeContent.setBreadcrumbs([{
          title: "Events",
          href: "/events"
        }, {
          title: groupEvent.type.title || "Details",
          href: groupEvent.typeKey ? `/events/${typeKeySlugMap[groupEvent.typeKey]}` : "/events"
        }, {
          title: query.data.groupEvent.title,
          href: `/events/${query.data.groupEvent.groupEventId}`
        }]);
      }
    };
    $[3] = activeContent;
    $[4] = query.data;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = query.data?.groupEvent?.groupEventId;
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useUniversalEffect(t2, t4);
  let t5;
  if ($[8] !== query) {
    t5 = <QueryContainer query={query} renderData={_temp} />;
    $[8] = query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
EventSingle.queries = {
  groupEvent: () => gql`
    query($groupEventId: String) {
      groupEvent(groupEventId: $groupEventId) {
        id
        ${EventProfile.fragments.GroupEvent()}

      }
    }
  `
};
function _temp(data) {
  return <EventProfile event={data.groupEvent} hideComments={data.groupEvent.typeKey === "office-hours"} />;
}